/**
 * 请求文件
 */

import reqwest from 'reqwest';
import requestRule from './request.rule';

export default function (ruleName, params, fn) {
	var rule = requestRule[ruleName]();

	return reqwest({
		url: rule.url,
		method: rule.method || 'GET',
		data: rule.formatRule(params),
		type: rule.type || 'json',
		crossOrigin: true,
		withCredentials: true,
		timeout: 10000,
		success: function (response) {
			if (fn && typeof fn === 'function') {
				fn(null, response)
			}
		},
		complete(response){
			console.log('response', ruleName, response);
		},
		error: function (err) {
      fn && fn(new Error(ruleName + '请求失败'), null);
		}
	});

}


/** WEBPACK FOOTER **
 ** ./lib/request.js
 **/